import React from "react";
import HeroSection from "../components/sections/HeroSection";
import { MarqueeBar, ProductsGridSection, IndustriesSection } from "../components/sections/HomeGrids";
import { WhyChooseSection, TestimonialsSection } from "../components/sections/WhyAndTestimonials";
import CTABanner from "../components/ui/CTABanner";

const HomePage = ({ navigate }) => (
  <div className="page-enter">
    <HeroSection navigate={navigate} />
    <MarqueeBar />
    <ProductsGridSection navigate={navigate} />
    <IndustriesSection />
    <WhyChooseSection />
    <TestimonialsSection />
    <CTABanner navigate={navigate} />
  </div>
);

export default HomePage;
